<template>
    <b-modal
        id="slu-module-modal"
        v-model="modal"
        ref="slu-module-modal"
        size="lg"
        :title="name"
        modal-class="apprentice-default-modal slu-module"
        :ok-title="$authUser.isStudent() ? $t('common.close') : $t('common.save')"
        :ok-only="$authUser.isStudent()"
        @ok="onOk"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')">
        <div class="module-modal">
            <div class="header">
                <img
                    class="banner"
                    :src="filePath"
                    alt="" />
                <div
                    class="optional-module"
                    v-b-tooltip.hover
                    v-if="!module.required"
                    :title="$t('slu_dashboard.optional_module')">
                    <i class="fad fa-fw fa-sparkles"></i>
                </div>
            </div>

            <div class="status-and-hours">
                <div
                    class="selected-option course-module-status"
                    v-if="this.$authUser.isAdmin() || this.$authUser.isTeacher()">
                    <span
                        class="tag-color"
                        :style="{ backgroundColor: `${statusObject.color}` }"></span>
                    <div class="tag-name">{{ statusObject.name }}</div>
                </div>

                <!--                <b-form-group v-if="this.$authUser.isAdmin() || this.$authUser.isTeacher()">-->
                <!--                    <design-2021-apprentice-multiselect-component-->
                <!--                        class="status-select"-->
                <!--                        :options="sluStatusTagsIn"-->
                <!--                        label="name"-->
                <!--                        :show-labels="false"-->
                <!--                        v-model="statusObject"-->
                <!--                        :multiple-select="false"-->
                <!--                        track-by="id">-->
                <!--                        <template slot="singleLabel" slot-scope="props">-->
                <!--                            <div class="selected-option course-module-status">-->
                <!--                                <span class="tag-color" :style="{backgroundColor: `${props.option.color}` }"></span>-->
                <!--                                <div class="tag-name">{{ props.option.name }}</div>-->
                <!--                            </div>-->
                <!--                        </template>-->

                <!--                        <template slot="option" slot-scope="props">-->
                <!--                            <div class="tag-option">-->
                <!--                                <span class="tag-color" :style="{backgroundColor: `${props.option.color}` }"></span>-->
                <!--                                <div class="tag-name">{{ props.option.name }}</div>-->
                <!--                            </div>-->
                <!--                        </template>-->
                <!--                    </design-2021-apprentice-multiselect-component>-->
                <!--                </b-form-group>-->

                <b-badge
                    class="student-module-status"
                    v-if="this.$authUser.isStudent()"
                    pill
                    variant="info"
                    :style="cssVars">
                    {{ statusObject.name }}
                </b-badge>

                <div class="hours">
                    <span class="btn-clock-one-thirty icon"></span>{{ hours }} {{ $t('slu_dashboard.hours') }}
                </div>

                <span
                    class="school-points"
                    v-if="sluSchoolSettingsIn.hours_to_point">
                    {{ hours / sluSchoolSettingsIn.hours_to_point }}
                    <span class="name-points">{{ sluSchoolSettingsIn.name_points }}</span>
                </span>
            </div>

            <div class="description">
                <design-2021-apprentice-display-html-component :html-content="description">
                </design-2021-apprentice-display-html-component>
            </div>

            <div
                class="labels"
                v-if="
                    Object.keys(module).length !== 0 &&
                    module.constructor === Object &&
                    module.slu_labels.length > 0 &&
                    !$authUser.isStudent()
                ">
                <b-badge
                    v-for="label in module.slu_labels"
                    pill
                    :key="label.id"
                    :style="{ backgroundColor: label.color }">
                    {{ label.name }}
                </b-badge>
            </div>

            <div class="feedback">
                <h4 class="title">Feedback</h4>
                <div class="feedback-input-wrapper">
                    <b-form-textarea
                        class="apprentice-textarea"
                        v-model="feedback"
                        v-if="!$authUser.isStudent()"
                        rows="4"
                        max-rows="6"
                        :placeholder="$t('slu_dashboard.fill_feedback_in')">
                    </b-form-textarea>
                    <span
                        class="feedback-text"
                        v-else>
                        {{ feedback !== '' && feedback !== null ? feedback : 'Er is nog geen feedback.' }}
                    </span>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-slu-module-modal-component',
    props: {
        sluStatusTagsIn: {
            type: Array,
            required: false,
        },
        sluSchoolSettingsIn: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            module: {},
            name: '',
            filePath: '',
            hours: 0,
            description: '',
            required: true,
            modal: false,
            statusObject: {},
            feedback: null,
        };
    },
    methods: {
        show(module) {
            this.module = module;
            this.name = module.name;
            this.filePath = module.file.path;
            this.hours = module.hours;
            this.description = module.description;
            this.required = module.required;
            if (module.slu_module_records[0]) {
                if (
                    module.slu_module_records[0].slu_status_tag !== null &&
                    module.slu_module_records[0].slu_status_tag_id !== null
                ) {
                    this.statusObject = this.sluStatusTagsIn.find(
                        (tag) => tag.id === module.slu_module_records[0].slu_status_tag_id,
                    );
                } else if (
                    module.slu_module_records[0].slu_status_tag === null &&
                    module.slu_module_records[0].slu_status_tag_id === null &&
                    module.slu_module_records[0].completed === 1
                ) {
                    this.statusObject = this.sluStatusTagsIn.find((tag) => tag.id === 'default_completed');
                } else {
                    this.statusObject = this.sluStatusTagsIn.find((tag) => tag.id === 'default_not_completed');
                }
                this.feedback = module.slu_module_records[0].feedback;
            } else {
                this.statusObject = this.sluStatusTagsIn.find((tag) => tag.id === 'default_not_completed');
            }

            this.modal = true;
        },

        onOk() {
            if (this.$authUser.isStudent()) {
                this.$bvModal.hide('slu-module-modal');
            } else {
                this.$emit('update-status', this.module, this.statusObject, this.feedback);
            }
        },
    },

    computed: {
        cssVars() {
            return {
                '--student-status-bgcolor': this.statusObject.color,
            };
        },
    },
};
</script>

<style scoped lang="scss">
.selected-option,
.tag-option {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    column-gap: 8px;

    .tag-color {
        display: inline-block;
        width: 13px;
        height: 13px;
        border-radius: 50%;
    }
}

.course-module-status {
    position: relative;
    padding: 8px 16px;
    border-radius: $border-radius-content;

    .tag-name,
    .tag-color {
        z-index: 45;
        font-weight: $font-weight-medium;
    }

    &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        background: $secondary-background-color;
        left: 0;
        border-radius: map-get($grid-gutter-spacing, 'eight');
    }
}

.header {
    position: relative;
    height: 175px;
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

    img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        object-position: center;
    }

    .optional-module {
        position: absolute;
        top: 10px;
        right: 10px;
        height: 41px;
        padding: map-get($grid-gutter-spacing, 'ten');
        background-color: $primary;
        color: $white;
        border-radius: 8px;
        z-index: 10;
    }
}

.status-and-hours {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    fieldset {
        margin-bottom: 0;
    }

    .status-select ::v-deep {
        width: 250px;

        .multiselect__tags {
            padding-top: map-get($grid-gutter-spacing, 'ten');
            padding-bottom: map-get($grid-gutter-spacing, 'ten');
        }

        .multiselect__single,
        .multiselect__option,
        input {
            font-size: $default-font-size;
        }
    }

    .hours,
    .school-points {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        font-size: $base-font-size;
        font-weight: $font-weight-medium;

        .icon {
            font-style: normal;
            font-weight: $font-weight-normal;
            color: $orange;
            margin-right: map-get($grid-gutter-spacing, 'eight');

            &:before {
                margin-right: 0;
            }
        }

        .name-points {
            color: $orange;
            font-size: 0.75rem;
            margin-left: map-get($grid-gutter-spacing, 'eight');
        }
    }

    &:has(+ .labels) {
        margin-bottom: map-get($grid-gutter-spacing, 'eight');
    }
}

.labels {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    column-gap: map-get($grid-gutter-spacing, 'ten');
    row-gap: map-get($grid-gutter-spacing, 'ten');
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');

    .badge {
        color: $white;
        font-size: 0.75rem;
        font-weight: $font-weight-medium;
        padding: map-get($grid-gutter-spacing, 'five') map-get($grid-gutter-spacing, 'ten');
    }
}

.description {
    color: $text-muted-color;
    font-weight: $font-weight-medium;
    line-height: 1.5;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    &:last-child {
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    }
}

.student-module-status {
    background-color: var(--student-status-bgcolor);
    font-size: 0.75rem;
    padding: 4px 8px;
}

.feedback-text {
    color: $text-muted-color;
    font-weight: $font-weight-medium;
    line-height: 1.5;
}
</style>
